const normalize = (value) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ł/g, 'l')
    .toLocaleLowerCase('pl-PL');

const resultLabel = (count) => {
    if (count === 1) return 'Znaleziono 1 wynik.';

    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;
    const noun = lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)
        ? 'wyniki'
        : 'wyników';

    return `Znaleziono ${count} ${noun}.`;
};

export function initFaqSearch() {
    const root = document.querySelector('[data-faq-search]');
    if (!root) return;

    const input = root.querySelector('[data-faq-search-input]');
    const clearButton = root.querySelector('[data-faq-search-clear]');
    const status = root.querySelector('[data-faq-search-status]');
    const emptyState = root.querySelector('[data-faq-search-empty]');
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];

    if (!input || !clearButton || !status || !emptyState) return;

    const searchableItems = items.map((item) => ({
        element: item,
        text: normalize(item.textContent || '')
    }));

    const filterFaq = () => {
        const query = input.value.trim();
        const terms = normalize(query).split(/\s+/).filter(Boolean);
        let visibleCount = 0;

        searchableItems.forEach(({ element, text }) => {
            const matches = terms.length === 0 || terms.every((term) => text.includes(term));
            element.hidden = !matches;
            element.open = terms.length > 0 && matches;
            if (matches) visibleCount += 1;
        });

        groups.forEach((group) => {
            const hasMatch = [...group.querySelectorAll('[data-faq-item]')]
                .some((item) => !item.hidden);
            group.hidden = !hasMatch;

            const categoryLink = root.querySelector(
                `[data-faq-category-link="${group.id}"]`
            );
            if (categoryLink) categoryLink.hidden = !hasMatch;
        });

        clearButton.hidden = terms.length === 0;
        emptyState.hidden = visibleCount !== 0;
        status.textContent = terms.length === 0
            ? `Dostępnych pytań: ${items.length}.`
            : resultLabel(visibleCount);
    };

    input.addEventListener('input', filterFaq);
    input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value) {
            input.value = '';
            filterFaq();
        }
    });

    clearButton.addEventListener('click', () => {
        input.value = '';
        filterFaq();
        input.focus();
    });

    const openLinkedAnswer = () => {
        const targetId = decodeURIComponent(window.location.hash.slice(1));
        const target = targetId ? document.getElementById(targetId) : null;

        if (!target?.matches('[data-faq-item]')) return;

        input.value = '';
        filterFaq();
        target.open = true;
    };

    window.addEventListener('hashchange', openLinkedAnswer);

    filterFaq();
    openLinkedAnswer();
}
